module.exports = __webpack_public_path__ + "../resources/images/laugh-f0494b1862b37926dd5a51ed7da7da1c.svg";